export default {
	token: '',
	// 取出Token
	gatToken() {
		return localStorage.getItem("token");
	},
	// 存入Token
	setToken(value) {
		localStorage.setItem('token', value)
		this.token = value
	},
	removetoken() {
		return localStorage.removeItem(token)
	},
	isTabChange: false //否是 tab 切换引起的请求
}